import { render } from "./PageHeader.vue?vue&type=template&id=4f9df517&scoped=true"
import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=4f9df517&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9df517"],['__file',"src/components/ui/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f9df517"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f9df517', __exports__)) {
    api.reload('4f9df517', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=4f9df517&scoped=true", () => {
    api.rerender('4f9df517', render)
  })

}


export default __exports__